import React from "react";

// inhouse icons
import { Search, X } from "@/components/icons_new";

const STATUS_OPTIONS = ["All", "In", "Low", "Out"];

const StockSearchControls = ({
  searchTerm,
  updateSearchTerm,
  categoryFilter,
  updateCategoryFilter,
  statusFilter,
  updateStatusFilter,
  categories = [],
}) => {
  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-col gap-[1em] border bg-white rounded-t-xl">
      <div className="bg-[#F8F8F8] relative px-3 py-2 rounded-md flex flex-row items-center gap-[1em]">
        <Search className="w-5 h-5 text-[#737373]" />
        <input
          type="text"
          placeholder="Search by product name or SKU..."
          value={searchTerm}
          onChange={(e) => {
            const sanitized = e.target.value
              .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
              .slice(0, 100);
            updateSearchTerm(sanitized);
          }}
          className="w-full text-[#000] bg-[#F8F8F8] placeholder:text-[#8a8a8a] outline-none font-medium"
        />
        {searchTerm && (
          <button
            onClick={() => updateSearchTerm("")}
            className="absolute right-3 text-[#999] hover:text-black"
            aria-label="Clear search"
          >
            <X className="w-5 h-5 text-[#000000]" />
          </button>
        )}
      </div>

      <div className="flex flex-wrap gap-3">
        <label className="flex items-center gap-2 text-sm text-[#555]">
          Category
          <select
            value={categoryFilter}
            onChange={(e) => updateCategoryFilter(e.target.value)}
            className="rounded-md border border-[#d9d9d9] bg-white px-3 py-1.5 text-sm font-medium text-[#333] outline-none focus:border-brand-500"
          >
            <option value="All">All</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </label>

        <label className="flex items-center gap-2 text-sm text-[#555]">
          Stock
          <select
            value={statusFilter}
            onChange={(e) => updateStatusFilter(e.target.value)}
            className="rounded-md border border-[#d9d9d9] bg-white px-3 py-1.5 text-sm font-medium text-[#333] outline-none focus:border-brand-500"
          >
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt === "In" ? "In Stock" : opt === "Low" ? "Low Stock" : opt === "Out" ? "Out of Stock" : opt}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
};

export default StockSearchControls;
